// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__c4oyD","title":"ClientReferral_title__UNPX5","itemText":"ClientReferral_itemText__3D2GO"};